// @import
import Alpine from "alpinejs";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(SplitText, ScrollTrigger);

Alpine.directive("animate-title", (element, {}, { cleanup }) => {
  console.log("title animation disabled");
  return;

  let splitText = new SplitText(element, {
    tag: "span",
    type: "words",
    wordsClass: "animate-title__words",
  });

  new SplitText(element, {
    tag: "span",
    type: "lines",
    linesClass: "animate-title__lines",
  });

  const wordsTween = gsap.from(splitText.words, {
    duration: 1,
    translateY: 110,
    rotate: 5,
    opacity: 0,
    ease: "power2",
    stagger: 0.05,
    scrollTrigger: {
      trigger: element,
      start: "top bottom",
      end: "bottom top",
    },
  });

  const setOpacityTween = gsap.to(element, {
    opacity: 1,
    duration: 0.1,
    ease: "power2",
    scrollTrigger: {
      trigger: element,
      start: "top bottom",
      end: "bottom top",
    },
  });

  cleanup(() => {
    wordsTween.kill();
    setOpacityTween.kill();
  });
});
